// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcoRecommendationsDataInner
 */
export interface EcoRecommendationsDataInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    priority?: EcoRecommendationsDataInnerPriorityEnum;
}


/**
 * @export
 */
export const EcoRecommendationsDataInnerPriorityEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;
export type EcoRecommendationsDataInnerPriorityEnum = typeof EcoRecommendationsDataInnerPriorityEnum[keyof typeof EcoRecommendationsDataInnerPriorityEnum];


/**
 * Check if a given object implements the EcoRecommendationsDataInner interface.
 */
export function instanceOfEcoRecommendationsDataInner(value: object): value is EcoRecommendationsDataInner {
    return true;
}

export function EcoRecommendationsDataInnerFromJSON(json: any): EcoRecommendationsDataInner {
    return EcoRecommendationsDataInnerFromJSONTyped(json, false);
}

export function EcoRecommendationsDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcoRecommendationsDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}

export function EcoRecommendationsDataInnerToJSON(json: any): EcoRecommendationsDataInner {
    return EcoRecommendationsDataInnerToJSONTyped(json, false);
}

export function EcoRecommendationsDataInnerToJSONTyped(value?: EcoRecommendationsDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'priority': value['priority'],
    };
}

